import styled, { css } from 'styled-components'

import { Skeleton } from '@blade/ui-kit'
import { PairIconSkeleton } from '@root/entities/pair/ui/pair-icon-skeleton'
import { mediaMaxDesktopSmall, Separator } from '@root/shared/ui-kit'

import { PairInformationRoot } from './pair-information'

export const PairInformationSkeleton: React.FC = () => (
  <Root>
    <Favorite>
      <Skeleton variant="circular" height={16} width={16} />
    </Favorite>
    <PairIconSkeleton size={34} />
    <Currency>
      <Skeleton height={12} />
      <Skeleton height={8} />
    </Currency>
    <Pool>
      <PoolItem>
        <Skeleton height={6} />
        <Skeleton height={10} />
      </PoolItem>
      <Separator vertical />
      <PoolItem>
        <Skeleton height={6} />
        <Skeleton height={10} />
      </PoolItem>
      <Separator vertical />
      <PoolItem>
        <Skeleton height={6} />
        <Skeleton height={10} />
      </PoolItem>
      <Separator vertical />
      <PoolItem>
        <Skeleton height={6} />
        <Skeleton height={10} />
      </PoolItem>
    </Pool>
  </Root>
)

const Root = styled(PairInformationRoot)`
  display: grid;
  grid-template-columns: auto auto auto 1fr;
`

const Favorite = styled.div`
  margin-inline: 4px 10px;
`

const Currency = styled.div`
  display: grid;

  grid-template-rows: auto auto;
  justify-items: start;
  align-items: center;

  margin-inline-start: 6px;
  gap: 4px;

  width: 300px;
`

const Pool = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  justify-self: end;
  gap: 14px;

  align-items: center;
`

const PoolItem = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  align-items: center;

  gap: 4px;
  width: 80px;

  ${mediaMaxDesktopSmall(css`
    width: 50px;
  `)}
`
